<div id="main-wrapper">
  <app-toolbar></app-toolbar>
  <router-outlet></router-outlet>
</div>